/* Yotpo's bottom-line widget renders its own text ("40 Reviews") inside
   .tm-bestseller-reviews asynchronously, so a plain Liquid/CSS edit can't
   touch it. Rewrite it to "(40)" — stars speak for themselves, per the
   reference layout. MutationObserver keeps this correct across Yotpo's
   own re-renders without looping (once rewritten, the text no longer
   matches the "N Review(s)" pattern). */
(function () {
  var containers = document.querySelectorAll('.tm-bestseller-reviews');
  if (!containers.length) return;

  function formatNode(el) {
    var match = el.textContent.trim().match(/^(\d+)\s+Reviews?$/i);
    if (match) el.textContent = '(' + match[1] + ')';
  }

  function scan(root) {
    root.querySelectorAll('.yotpo-sr-bottom-line-text--right-panel').forEach(formatNode);
  }

  containers.forEach(function (container) {
    scan(container);
    new MutationObserver(function () { scan(container); })
      .observe(container, { childList: true, subtree: true, characterData: true });
  });
})();
